import React, { useState, useEffect } from "react";
import { Toast, Fade } from "reactstrap";  // Import Fade if needed
import { useSelector, useDispatch } from "react-redux";
import { hideToast } from "../../store/features/toast/toastSlice";

interface ToastType {
  type: "success" | "error" | "warning";
  show: boolean;
  customClass?: string;
  message?: string;
}

const ToastComponent: React.FC = () => {
  const toast: ToastType = useSelector((state: any) => state.toast); // Replace 'any' with your RootState type
  const [showToast, setShowToast] = useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setShowToast(toast.show);

    if (toast.show) {
      const timeout = setTimeout(() => {
        setShowToast(false);
        dispatch(hideToast());
      }, 3000); // 3 seconds

      return () => clearTimeout(timeout); // Cleanup the timeout when the component unmounts or when the toast state changes
    }
  }, [toast.show, dispatch]);

  let toastClass: string | undefined;
  let textToast: string | undefined;
  let iconClass: string | undefined = toast.customClass;

  if (toast.type === "success") {
    toastClass = "success-txt";
    textToast = "toastSuccess";
    iconClass = "icon-check-circle-fill";
  } else if (toast.type === "error") {
    toastClass = "error-txt";
    textToast = "toastError";
    iconClass = "icon-x-circle-fill";
  } else if (toast.type === "warning") {
    toastClass = "warning-txt";
    textToast = "toastWarning";
    iconClass = "icon-info-circle";
  }

  return (
    <Fade in={showToast} timeout={300}>  {/* Apply Fade component for transition */}
      <Toast
        onClose={() => {
          setShowToast(false);
          dispatch(hideToast());
        }}
        className={toastClass}
        isOpen={showToast}
        fade={false}  // Disable internal fade since we're using Fade component externally
      >
        <div className="tost-center">
          <div className="Tost_Content">
            <span className={iconClass}></span>
            <div className={`txtcontain ${textToast}`}>
              {toast.message}
            </div>
          </div>
        </div>
      </Toast>
    </Fade>
  );
};

export default ToastComponent;


// import React, { useState, useEffect } from "react";
// import { Toast } from "reactstrap";
// import { useSelector, useDispatch } from "react-redux";
// import { hideToast } from "../../store/features/toast/toastSlice";

// interface ToastType {
//   type: "success" | "error" | "warning";
//   show: boolean;
//   customClass?: string;
//   message?: string;
// }

// const ToastComponent: React.FC = () => {
//   const toast: ToastType = useSelector((state: any) => state.toast); // Replace 'any' with your RootState type
//   const [showToast, setShowToast] = useState<boolean>(false);
//   const dispatch = useDispatch();

//   useEffect(() => {
//     setShowToast(toast.show);

//     if (toast.show) {
//       const timeout = setTimeout(() => {
//         setShowToast(false);
//         dispatch(hideToast());
//       }, 3000); // 3 seconds

//       return () => clearTimeout(timeout); // Cleanup the timeout when the component unmounts or when the toast state changes
//     }
//   }, [toast.show, dispatch]);

//   let toastClass: string | undefined;
//   let textToast: string | undefined;
//   let iconClass: string | undefined = toast.customClass;

//   if (toast.type === "success") {
//     toastClass = "success-txt";
//     textToast = "toastSuccess";
//     iconClass = "icon-check-circle-fill";
//   } else if (toast.type === "error") {
//     toastClass = "error-txt";
//     textToast = "toastError";
//     iconClass = "icon-x-circle-fill";
//   } else if (toast.type === "warning") {
//     toastClass = "warning-txt";
//     textToast = "toastWarning";
//     iconClass = "icon-info-circle";
//   }

//   return (
//     <Toast
//       onClose={() => {
//         setShowToast(false);
//         dispatch(hideToast());
//       }}
//       className={toastClass}
//       isOpen={showToast}
//       fade={true}  // Add fade prop here to enable the fade transition
//       timeout={300}  // Set timeout to avoid the warning (default is 300ms)
//     >
//       <div className="tost-center">
//         <div className="Tost_Content">
//           <span className={iconClass}></span>
//           <div className={`txtcontain ${textToast}`}>
//              {toast.message}
//           </div>
//         </div>
//       </div>
//     </Toast>
//   );
// };

// export default ToastComponent;
